export const FETCH_POKEMONS = 'FETCH_POKEMONS';
export const FETCH_LOADING = 'FETCH_LOADING';
export const FETCH_LOADED = 'FETCH_LOADED';
export const POKEMON_DETAIL = 'POKEMON_DETAIL';
export const PREV_PATH = 'PREV_PATH'